/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { isBrowser } from '@/utils/browser';
import queryString from 'query-string';
import { BensServicosTabIds } from '@/data/misc/bens-servicos-tabs';
import Styles from './BensServicosTemplate.css';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import TabGroupBensServicos from '@/components/molecules/TabGroupBensServicos';
import BensServicosBanner from '@/components/organisms/BensServicosBanner';
import BensServicosPF from '../BensServicosPF';
import BensServicosPJ from '../BensServicosPJ';
import BensServicosConteudos from '@/components/organisms/BensServicosConteudos';

function BensServicosTemplate() {
  const [activeTab, setActiveTab] = useState(BensServicosTabIds.paravoce);
  const router = useRouter();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (!isBrowser()) return;
    const parsed = queryString.parseUrl(router.asPath);
    if (parsed && parsed.query && parsed.query.t) {
      setActiveTab(BensServicosTabIds[parsed.query.t.toLowerCase()]);
    }
  }, []);

  useEffect(() => {
    const text = Object.keys(BensServicosTabIds)
      .map((key) => {
        if (BensServicosTabIds[key] === activeTab) {
          return key;
        }
        return undefined;
      })
      .filter((v) => !!v)
      .pop();

    const extra = process.env.NODE_ENV === 'production' ? '.html' : '';

    const parsed = queryString.parse(queryString.extract(router.asPath));
    parsed.t = text;
    const str = queryString.stringify(parsed);

    router.replace('/parcelamento-bens-servicos', `/parcelamento-bens-servicos${extra}?${str}`, {
      scroll: false,
      shallow: true,
    });
  }, [activeTab]);

  return (
    <>
      <Head>
        <title>Parcelamento Bens e Serviços | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Parcelamento e financiamento de bens e serviços com a segurança Santander. Condições flexíveis para facilitar suas conquistas pessoais ou da sua empresa."
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/parcelamento-bens-servicos.html"
        />
        <meta name="robots" content="index, follow" />

        <meta
          name="keywords"
          content="empréstimo pessoal, simulação de financiamento, crédito pessoal, crédito online, financiamento pessoal, crédito para empresas, empréstimo para empresas, crédito para pequenas empresas, santander parcelamento, bens e serviços parcelados"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta
          property="og:title"
          content="Parcelamento Bens e Serviços | Santander Financiamentos"
        />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/parcelamento-bens-servicos.html"
        />
        <meta property="og:site_name" content="" />
        <meta
          property="og:description"
          content="Parcelamento e financiamento de bens e serviços com a segurança Santander. Condições flexíveis para facilitar suas conquistas pessoais ou da sua empresa."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/bens-e-servicos/hero-pf/hero-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta
          name="twitter:title"
          content="Parcelamento Bens e Serviços | Santander Financiamentos"
        />
        <meta
          name="twitter:description"
          content="Parcelamento e financiamento de bens e serviços com a segurança Santander. Condições flexíveis para facilitar suas conquistas pessoais ou da sua empresa."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/parcelamento-bens-servicos.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/bens-e-servicos/hero-pf/hero-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 />
      <BensServicosBanner tab={activeTab} />

      <div>
        <TabGroupBensServicos tab={activeTab} onTabSelected={handleTabChange} />

        {activeTab === BensServicosTabIds.paravoce && <BensServicosPF />}
        {activeTab === BensServicosTabIds.parasuaempresa && <BensServicosPJ />}
      </div>

      <BensServicosConteudos />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosTemplate;
